<div class="wrapper">
  <app-idiom></app-idiom>
  <div class="area-name">{{ title }}</div>
</div>
